<template>
    <CustomInput
        :label="label"
        @append-click="handleGenAppendClick"
    >
        <template #prepend>
            <el-select
                style="width:90px"
                v-model="innerType"
                placeholder="请选择"
                class="customInput_prepend_select"
            >
                <el-option value="1" :label="label + '选择'"></el-option>
                <el-option value="2" :label="label + '搜索'"></el-option>
            </el-select>
        </template>

        <ESelect
            v-if="innerType === '1'"
            v-model="innerIds"
            filterable
            clearable
            :placeholder="'请输入' + label + '名称、ID搜索'"
            multiple
            collapse-tags
            remote
            reserve-keyword
            :loading="searchLoading"
            :ref="'eselect_' + mode"
            @visible-change="handleVisibleChange"
            :remote-method="(search) => appEntrySearchList(search)"
        >
            <p class="option-select">
                <el-button type="text" @click="handleSelectAll('all')">全选</el-button>
                <el-button type="text" @click="handleSelectAll('cancel')">取消全选</el-button>
            </p>
            <el-option
                v-for="item in DataList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
        </ESelect>

        <el-input
            v-if="innerType === '2'"
            v-model="innerSearch"
            :placeholder="'请输入' + label + '名称搜索'"
            clearable
            style="width:180px"
        ></el-input>

        <template #append v-if="innerType === '1'">
            <i class="el-icon-document-copy" />
        </template>
        <template #appendOrther>
            <i class="el-icon-close" :style="{ color: 'red', cursor: 'pointer' }" @click="$emit('del')" />
        </template>
    </CustomInput>
</template>

<script>
import CustomInput from '@/components/CustomInput'
import { batchSelectModal } from '@/components/modal'
import workOrderAPI from '@/api/workOrder/material.js'

export default {
    name: 'OrderProjectFilter',
    components: {
        CustomInput,
    },
    model: {
        prop: 'value',
        event: 'input',
    },
    props: {
        // 'work_order' | 'project_id' — 对应 get_search_list 的 search_type
        mode: {
            type: String,
            default: 'work_order',
        },
        // 显示在 label 上的文字，如"工单"、"项目"
        label: {
            type: String,
            default: '工单',
        },
        // 搜索接口场景: 'work_order'(工单管理·默认·/work_order/get_search_list)
        //   | 'schedule_manage'(排单管理·/work_order/schedule_manage/get_search_list·挂7543·BUG-002-AY)
        searchApi: {
            type: String,
            default: 'work_order',
        },
        // v-model 对象: { type: '1'|'2', ids: [], search: '' }
        value: {
            type: Object,
            default: () => ({ type: '1', ids: [], search: '' }),
        },
    },
    data() {
        return {
            innerType: '1',
            innerIds: [],
            innerSearch: '',
            DataList: [],       // 已选项缓存 + 远程搜索结果
            searchLoading: false,
        }
    },
    watch: {
        value: {
            handler(val) {
                if (!val) return
                // 内容相等则跳过（避免自发 emit 回灌→新数组引用→innerIds watcher→再 emit 的死循环·切换卡死）
                if ((val.type || '1') === this.innerType
                    && JSON.stringify(val.ids || []) === JSON.stringify(this.innerIds)
                    && (val.search || '') === this.innerSearch) {
                    return
                }
                this.innerType = val.type || '1'
                this.innerIds = val.ids ? [...val.ids] : []
                this.innerSearch = val.search || ''
            },
            deep: true,
            immediate: true,
        },
        innerType(n, o) {
            if (n === o) return
            if (n === '1') {
                this.innerSearch = ''
            } else {
                this.innerIds = []
            }
            this.emitInput()
        },
        innerIds() {
            this.emitInput()
        },
        innerSearch() {
            this.emitInput()
        },
    },
    methods: {
        emitInput() {
            this.$emit('input', {
                type: this.innerType,
                ids: this.innerIds,
                search: this.innerSearch,
            })
        },

        // 远程搜索
        async appEntrySearchList(search, extra = {}, cb) {
            try {
                const params = {
                    search_type: this.mode,
                    search,
                    ...extra,
                }
                this.searchLoading = true
                // 排单管理走独立接口(挂7543)·工单管理走原接口(挂3866)·BUG-002-AY
                const apiFn = this.searchApi === 'schedule_manage'
                    ? workOrderAPI.postScheduleManageSearchList
                    : workOrderAPI.postSearchWorkOrderMethodOptions
                const { data } = await apiFn(params)
                const list = data.list
                const errList = data.err_list || []

                if (params.batch_search) {
                    // 第三参 err_groups：后端把「未找到」的单按当前状态归类（仅 search_type=work_order 非空）。
                    // 纯增参数，err_list 与剔除语义一字未动。
                    cb(errList, () => {
                        const ids = list.map(v => v.id)
                        this.DataList = [
                            ...this.DataList.filter(
                                v => this.innerIds.includes(v.value) && !ids.includes(v.value)
                            ),
                            ...list.map(v => ({ ...v, value: v.id, label: v.name })),
                        ]
                        this.innerIds = [...new Set([...this.innerIds, ...ids])]
                    }, data.err_groups || [])
                } else {
                    this.DataList = list.map(v => ({ ...v, value: v.id, label: v.name }))
                }
            } catch (error) {
                this.$message.warning(error && error.info ? error.info : '搜索失败')
            } finally {
                this.searchLoading = false
            }
        },

        // 批量粘贴入口
        handleGenAppendClick() {
            const batchTip = this.mode === 'work_order'
                ? '输入或粘贴工单ID/名称，每行一个'
                : '项目名/ID，每行一个'

            const onSubmit = (data, callback) => {
                this.appEntrySearchList(
                    '',
                    { batch_search: data },
                    (errs, cb, errGroups) => {
                        callback()
                        if (errs && errs.length) {
                            const onOk = () => {
                                cb()
                                vm.close()
                            }
                            // 后端给了归类（仅工单类型）→ 分组弹框；否则退回原弹框，行为与改动前完全一致。
                            // ⚠️ 两条分支的「剔除」动作是同一个 onOk —— 归类只改展示，不改剔除语义。
                            if (errGroups && errGroups.length) {
                                delErrGroupList({
                                    tip: '未找到以下数据信息，请核实，是否需要剔除未找到的?（已按工单当前状态归类，可分组复制）',
                                    groups: errGroups,
                                    onOk,
                                })
                            } else {
                                delErrList({
                                    tip: '未找到以下数据信息，请核实，是否需要剔除未找到的?',
                                    list: errs,
                                    onOk,
                                })
                            }
                        } else {
                            cb()
                            vm.close()
                        }
                    }
                )
            }

            const batchTitle = this.mode === 'work_order' ? '批量筛选工单' : '批量筛选项目'
            const { vm, delErrList, delErrGroupList } = batchSelectModal({
                title: batchTitle,
                props: {
                    tip: batchTip,
                    hasLoading: true,
                },
                cbs: { onSubmit },
            })
        },

        // 下拉展开时同步已选项 label，避免 label 丢失
        handleVisibleChange(visible) {
            if (visible) {
                const refKey = 'eselect_' + this.mode
                const options = (this.$refs[refKey] && this.$refs[refKey].selected) || []
                const listData = options.map(v => v.$options.propsData)
                this.$set(this, 'DataList', listData)
            }
        },

        // 全选 / 取消全选
        handleSelectAll(selectType) {
            if (selectType === 'all') {
                const merged = [...this.innerIds, ...this.DataList.map(v => v.value)]
                this.innerIds = [...new Set(merged)]
            } else {
                const optionIds = this.DataList.map(v => v.value)
                this.innerIds = this.innerIds.filter(id => !optionIds.includes(id))
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.option-select {
    padding: 0 10px;
    margin: 0;
}
</style>
